export var ITrackingTypes;
(function (ITrackingTypes) {
    ITrackingTypes["image"] = "image";
    ITrackingTypes["face"] = "face";
    ITrackingTypes["world"] = "world";
    ITrackingTypes["noTrackingScreen"] = "noTrackingScreen";
    ITrackingTypes["content360"] = "content360";
})(ITrackingTypes || (ITrackingTypes = {}));
export var IImageTrackingOrientation;
(function (IImageTrackingOrientation) {
    IImageTrackingOrientation["upright"] = "upright";
    IImageTrackingOrientation["flat"] = "flat";
})(IImageTrackingOrientation || (IImageTrackingOrientation = {}));
